import React from 'react';
import ReactDOM from 'react-dom';
import './UI.css';

export function Button({ children, variant = 'primary', size = 'md', loading, disabled, icon, ...props }) {
  return (
    <button
      className={`btn btn--${variant} btn--${size} ${loading ? 'btn--loading' : ''}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <span className="btn-spinner" /> : icon ? <span className="btn-icon">{icon}</span> : null}
      {children}
    </button>
  );
}

export function Input({ label, error, helper, ...props }) {
  return (
    <div className={`field ${error ? 'field--error' : ''}`}>
      {label && <label className="field-label">{label}</label>}
      <input className="field-input" {...props} />
      {error && <span className="field-error">{error}</span>}
      {helper && !error && <span className="field-helper">{helper}</span>}
    </div>
  );
}

export function Select({ label, error, children, ...props }) {
  return (
    <div className={`field ${error ? 'field--error' : ''}`}>
      {label && <label className="field-label">{label}</label>}
      <select className="field-input field-select" {...props}>
        {children}
      </select>
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}

export function Textarea({ label, error, ...props }) {
  return (
    <div className={`field ${error ? 'field--error' : ''}`}>
      {label && <label className="field-label">{label}</label>}
      <textarea className="field-input field-textarea" {...props} />
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}

export function Card({ children, className = '', ...props }) {
  return <div className={`card ${className}`} {...props}>{children}</div>;
}

export function Badge({ children, variant = 'default' }) {
  return <span className={`badge badge--${variant}`}>{children}</span>;
}

export function Modal({ open, onClose, title, children, className = '' }) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div className={`modal ${className}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>,
    document.body
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="page-action">{action}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon, sub, variant }) {
  return (
    <div className={`stat-card ${variant ? `stat-card--${variant}` : ''}`}>
      <div className="stat-top">
        <span className="stat-label">{label}</span>
        {icon && <span className="stat-icon">{icon}</span>}
      </div>
      <div className="stat-value">{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}

export function EmptyState({ title, description, icon }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-icon">{icon}</div>}
      <div className="empty-title">{title}</div>
      {description && <div className="empty-desc">{description}</div>}
    </div>
  );
}
